"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _commonComponent = require("../../propTypes/commonComponent");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("../../styles/components/common/Buttons.css");
var _excluded = ["children", "styleName", "baseClass", "customClass", "classModifiers", "disabled", "dataTest"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var APButton = function APButton(props) {
  var children = props.children,
    styleName = props.styleName,
    baseClass = props.baseClass,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    disabled = props.disabled,
    dataTest = props.dataTest,
    otherProps = _objectWithoutProperties(props, _excluded);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass, classModifiers);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", _extends({
    disabled: disabled,
    "data-test": dataTest,
    className: bemClasses('btn', [styleName, classModifiers])
  }, otherProps), children));
};
APButton.defaultProps = {
  name: '',
  value: '',
  type: '',
  autoFocus: false,
  disabled: false,
  baseClass: 'ap-button',
  styleName: _commonComponent.styleNames.general
};
APButton.propTypes = {
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  type: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  baseClass: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  styleName: _commonComponent.styleNamePropType
};
var _default = exports["default"] = APButton;